import { render, staticRenderFns } from "./productBuyers.vue?vue&type=template&id=558419b3&scoped=true&lang=html&"
import script from "./productBuyers.vue?vue&type=script&lang=js&"
export * from "./productBuyers.vue?vue&type=script&lang=js&"
import style0 from "./productBuyers.vue?vue&type=style&index=0&id=558419b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558419b3",
  null
  
)

export default component.exports